import {
animation, trigger, animateChild, group,
transition, animate, style, query
} from '@angular/animations';
import { fadeOutAndIn } from './animation.fadeOutSlideInLeft';
  
export const routeAnimations =
trigger('routeAnimations', [
    transition('* => ProjectPage', fadeOutAndIn),
]);